module.exports = __webpack_public_path__ + "assets/img/youtube_1399.78b8ea6b.png";